import { render, staticRenderFns } from "./UploadDocumentDialog.vue?vue&type=template&id=1454eabd&scoped=true&"
import script from "./UploadDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocumentDialog.vue?vue&type=style&index=0&id=1454eabd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1454eabd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1454eabd')) {
      api.createRecord('1454eabd', component.options)
    } else {
      api.reload('1454eabd', component.options)
    }
    module.hot.accept("./UploadDocumentDialog.vue?vue&type=template&id=1454eabd&scoped=true&", function () {
      api.rerender('1454eabd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/components/UploadDocumentDialog.vue"
export default component.exports